import request from '@/utils/request'

export function doLogin(params) {
  return request({
    url: '/system/user/sysUser/doLogin',
    headers: {
      repeatSubmit: true,
      isToken: false
    },
    method: 'post',
    data: params
  })
}

export function doLogout(params) {
  return request({
    url: '/system/user/sysUser/doLogout',
    headers: {
      repeatSubmit: true,
      isToken: false
    },
    method: 'post',
    data: params
  })
}


export function doMobile(params) {
  return request({
    url: '/system/user/sysUser/mobile',
    headers: {
      repeatSubmit: true
    },
    method: 'post',
    params: params
  })
}


